/* unplugin-vue-components disabled */import script from "./AfterSalesAudit@3.0.vue?vue&type=script&setup=true&lang=js"
export * from "./AfterSalesAudit@3.0.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__